import React from "react";
import LegalPage from "./LegalPage";
import { SUPPORT_EMAIL } from "../components/SupportCard";

const H = ({ children }) => (
  <h2 className="text-white text-[17px] font-semibold tracking-tight mt-8 mb-2">{children}</h2>
);

export default function Terms() {
  return (
    <LegalPage title="Terms of Service" updated="February 2026">
      <p>
        Welcome to FlowFinder. By accessing or using the FlowFinder website,
        mobile-web application, or any of its features (the “Service”), you agree
        to be bound by these Terms of Service. If you do not agree, please do not
        use the Service.
      </p>

      <H>1. Educational use only</H>
      <p>
        FlowFinder is a market-scanner and analytics tool intended for
        educational and informational purposes only. Nothing on the Service
        constitutes financial, investment, tax or legal advice. All indicators,
        setup scores, charts, signals and rankings are produced algorithmically
        from third-party market data and may contain errors, omissions or
        delays. Trading and investing involve substantial risk of loss. Past
        performance is not indicative of future results. You are solely
        responsible for your own trading decisions.
      </p>

      <H>2. Accounts</H>
      <p>
        You must provide accurate registration information and keep your
        credentials confidential. You are responsible for all activity that
        occurs under your account. We may suspend or terminate accounts that
        violate these terms or are used for abusive, fraudulent or illegal
        purposes.
      </p>

      <H>3. Subscriptions &amp; billing</H>
      <p>
        Paid plans (Pro, Elite) are billed monthly in advance through Stripe.
        Subscriptions renew automatically until cancelled. You may cancel at any
        time from your account; cancellations take effect at the end of the
        current billing period. Fees already paid are non-refundable except as
        required by applicable law.
      </p>

      <H>4. Acceptable use</H>
      <p>You agree not to:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>resell, redistribute or scrape data, signals or content from the Service;</li>
        <li>reverse-engineer, decompile or attempt to extract source code;</li>
        <li>interfere with, overload or attempt to bypass any rate limit, access control or security feature;</li>
        <li>use the Service in any way that violates applicable laws or third-party rights.</li>
      </ul>

      <H>5. Third-party data</H>
      <p>
        Market data is provided by third-party feeds (such as Finnhub). FlowFinder
        does not warrant the accuracy, completeness, timeliness or availability
        of any data and is not liable for losses resulting from data errors,
        outages or delays. Some features may be labelled DELAYED or unavailable
        outside US market hours.
      </p>

      <H>6. Intellectual property</H>
      <p>
        The Service, including its design, code, brand marks, indicators and
        scoring methodology, is the property of FlowFinder and is protected by
        applicable intellectual-property laws. You may not copy, modify or
        create derivative works without our prior written consent.
      </p>

      <H>7. Disclaimer of warranties</H>
      <p>
        The Service is provided <em>“as is”</em> and <em>“as available”</em>
        without warranties of any kind, express or implied. To the maximum
        extent permitted by law, FlowFinder disclaims all warranties, including
        merchantability, fitness for a particular purpose and non-infringement.
      </p>

      <H>8. Limitation of liability</H>
      <p>
        To the maximum extent permitted by law, FlowFinder shall not be liable
        for any indirect, incidental, special, consequential or punitive damages
        — including trading losses, lost profits or lost data — arising out of
        or in connection with your use of the Service. Our total liability is
        limited to the amount you paid us in the twelve months before the event
        giving rise to the claim.
      </p>

      <H>9. Changes</H>
      <p>
        We may update these Terms from time to time. Material changes will be
        communicated in-app or by email. Continued use of the Service after the
        update constitutes acceptance of the revised Terms.
      </p>

      <H>10. Contact</H>
      <p>
        Questions about these Terms? Email{" "}
        <a className="text-[var(--bull)]" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
      </p>
    </LegalPage>
  );
}
